import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { partnerLogin } from "../apis/auth";
import { useAuthStore } from "../store/useAuthStore";
import { Container, Card, CardContent, Input, Button } from "../components/ui";

export default function PartnerLogin() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!phone.trim() || !password) {
      setError("Phone and password are required");
      return;
    }
    setIsLoading(true);
    try {
      const { user, token } = await partnerLogin(phone, password);
      setAuth(user, token);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary-50 py-12 px-4">
      <Container>
        <div className="max-w-md mx-auto">
          <Card>
            <CardContent className="p-6 sm:p-8">
              <h1 className="text-2xl font-bold text-secondary-900 mb-2">
                Partner Login
              </h1>
              <p className="text-secondary-600 mb-6">
                Sign in to manage your service requests
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                  label="Phone Number"
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="10-digit mobile number"
                  required
                />
                <Input
                  label="Password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Your password"
                  required
                />
                {error && (
                  <p className="text-sm text-red-600">{error}</p>
                )}
                <Button
                  type="submit"
                  fullWidth
                  isLoading={isLoading}
                  disabled={isLoading}
                >
                  Sign In
                </Button>
              </form>

              <p className="mt-6 text-center text-sm text-secondary-600">
                New partner?{" "}
                <Link to="/" className="text-primary-600 font-medium hover:underline">
                  Register here
                </Link>
              </p>
            </CardContent>
          </Card>
        </div>
      </Container>
    </div>
  );
}
